import React from "react";

const Java_Quiz = () => {
  return (
    <div>
      <h1>Java Quiz</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Quiz in Java.</p>
    </div>
  );
};

export default Java_Quiz;
